<nav class="navbar navbar-expand-lg">
  <div>
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" routerLink="/home">
          <i class="fas fa-arrow-left"></i>
          Back
        </a>
      </li>
      @if (hasPaidCompletionsMi) {
        <li class="nav-item">
          <a class="nav-link active" routerLink="/mi/completions-paid" routerLinkActive="tab-active">
            Completions MI
          </a>
        </li>
      }
      @if (hasHostedMi) {
        <li class="nav-item">
          <a class="nav-link active" routerLink="/mi/hosted" routerLinkActive="tab-active">
            Hosted MI
          </a>
        </li>
      }
      @if (hasHostedMi || hasLGSSMI) {
        <li class="nav-item">
          <a class="nav-link active" routerLink="/mi/surveying-services" routerLinkActive="tab-active">
            Surveying Services MI
          </a>
        </li>
      }
      @for (report of genericReports; track report) {
        <li class="nav-item">
          <a class="nav-link active" routerLinkActive="tab-active" [routerLink]="'/mi/' + report.path">
            {{ report.displayName }}
          </a>
        </li>
      }
    </ul>
  </div>
</nav>
